<template>
  <div>
    <a
      @click="fnSwitchUser()"
      class="p-2"
      data-toggle="tooltip"
      data-placement="top"
      title="Switch user"
      ><i class="las la-sign-in-alt text-primary fs-1300 mt-1"></i
    ></a>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../../services/message.service'
import * as authService from '../../../services/auth.service'

export default {
  name: 'SwitchUser',
  props: ['userId'],
  components: {},
  data() {
    return {
      errors: {},
      id: ''
    }
  },
  computed: {
    ...mapGetters(['getIsUserSettingUpdate'])
  },

  methods: {
    ...mapActions(['fetchIsUserSettingUpdate']),

    fnSwitchUser: async function () {
      try {
        const response = await authService.switchUserLogin({
          userId: this.userId
        })
        this.errors = {}

        if (
          response.token_scope == 'admin' ||
          response.token_scope == 'staff'
        ) {
          this.$router.push({ name: 'admin.dashboard' })
        } else if (response.token_scope == 'bdm') {
          this.$router.push({ name: 'bdm.dashboard' })
        } else if (response.token_scope == 'dealer') {
          this.$router.push({ name: 'dealer.dashboard' })
        } else if (response.token_scope == 'referral-partner') {
          this.$router.push({ name: 'referralPartner.dashboard' })
        } else {
          this.$router.push({ name: 'dealer.dashboard' })
        }
        this.fetchIsUserSettingUpdate(true)
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Switch user login',
              error.response.data.message
            )
            break
          case 403:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Switch user login',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Switch user login',
              error.response.data.message
            )
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Switch user login',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Switch user login',
              'Something wrong, please try again!'
            )
            break
        }

        this.fetchIsUserSettingUpdate(false)
      }
    }
  }
}
</script>
